/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import epoAxios from './epoAxios';
import { contextPathApi } from '../../settings';
import { getAccessToken } from '../../redux/features/auth/auth.service';

const constantHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const HTTP_STATUS = Object.freeze({
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  NETWORK_CONNECT_TIMEOUT: 599,
});

const generateAuthHeaders = () => {
  const accessToken = getAccessToken();
  if (!accessToken) return {};
  return {
    Authorization: `Bearer ${accessToken}`,
  };
};

const httpRequest = (url, options = {}) => {
  const {
    method = 'GET',
    headers: defaultHeaders = {},
    params: defaultParams = {},
    data: defaultData,
    withDefaultPath = true,
    ...otherOptions
  } = options;
  const requestUrl = withDefaultPath ? `${contextPathApi}${url}` : url;

  return ({ headers = {}, params = {}, data, ...other } = {}) => {
    return epoAxios({
      url: requestUrl,
      method,
      headers: {
        ...generateAuthHeaders(),
        ...constantHeaders,
        ...generateTracingId(),
        ...defaultHeaders,
        ...headers,
      },
      params: {
        ...defaultParams,
        ...params,
      },
      data: data || defaultData,
      ...otherOptions,
      ...other,
      signal: otherOptions.signal,
    });
  };
};

const generateTracingId = () => {
  const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
  return {
    traceparent: `00-${genRanHex(32)}-${genRanHex(16)}-00`,
  };
};

export default httpRequest;
